<template>
  <li class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"  data-dropdown-toggle="click">
    <a href="#" class="m-nav__link m-dropdown__toggle">
      <span class="m-nav__link-badge m-badge m-badge--dot m-badge--info m--hide"></span>
      <span class="m-nav__link-icon">
        <span class="m-nav__link-icon-wrapper">
          <i class="flaticon-stopwatch notification-i" :title="'quick_actions' | translate | capitalize"></i>
        </span>
      </span>
    </a>
    <div class="m-dropdown__wrapper">
      <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust arrow-user"></span>
      <div class="m-dropdown__inner">
        <div class="m-dropdown__header m--align-center" style="background: url(assets/app/media/img/misc/quick_actions_bg.jpg); background-size: cover;">
          <span class="m-dropdown__header-title">
            {{ 'quick_actions' | translate | capitalize }}
          </span>
          <span class="m-dropdown__header-subtitle">
            {{ 'shortcuts' | translate | capitalize }}
          </span>
        </div>
        <div class="m-dropdown__body m-dropdown__body--paddingless">
          <div class="m-dropdown__content">
            <div class="m-scrollable" data-scrollable="false" data-max-height="380" data-mobile-max-height="200">
              <div class="m-nav-grid m-nav-grid--skin-light">
                <div class="m-nav-grid__row">
                  <a class="m-nav-grid__item">
									  <router-link class="m-nav-grid__item" :to="{ name: 'cameras'}">
                      <i class="m-nav-grid__icon flaticon-profile"></i>
                      <span class="m-nav-grid__text">
                        {{ 'cameras' | translate | capitalize }}
                      </span>
                    </router-link>
									</a>
                  <a class="m-nav-grid__item">
                    <router-link class="m-nav-grid__item" :to="{ name: 'adminControlPoints'}">
                      <i class="m-nav-grid__icon flaticon-map-location"></i>
                      <span class="m-nav-grid__text">
                        {{ 'control_points' | translate | capitalize }}
                      </span>
                    </router-link>
									</a>
                </div>
                <div class="m-nav-grid__row">
                  <router-link class="m-nav-grid__item" :to="{ name: 'createStaff'}">
										<i class="m-nav-grid__icon flaticon-folder"></i>
										<span class="m-nav-grid__text">
											{{ 'new_staff' | translate | capitalize }}
										</span>
                  </router-link>
                  <a class="m-nav-grid__item">
									  <router-link class="m-nav-grid__item" :to="{ name: 'createCargoStaff'}">
                      <i class="m-nav-grid__icon flaticon-clipboard"></i>
                      <span class="m-nav-grid__text">
                        {{ 'new_cargo_staff' | translate | capitalize }}
                      </span>
                    </router-link>  
									</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// QuickActions.vue